import React from 'react';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';

class BaseLineupPlayersComponent extends BaseLineupPlayers {
    getPlayersView() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        return lineup.players.map((player, index) => this.getPlayerView(player, index));
    }

    render() {
        return (
            <table className="table">
                <tbody>{this.getPlayersView()}</tbody>
            </table>
        );
    }
}

export {BaseLineupPlayersComponent};
